export default "__VITE_ASSET__LVJA$FY0__"